

















import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
  props: {
    count: {
      type: Number,
      default: 0,
    },
    pagerCount: {
      type: Number,
      default: 7,
    },
    followLayout: {
      type: String,
      default: '',
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50, 100],
    },
  },
  setup(props, { emit }) {
    const setQuery = (params) => {
      emit('update:query', params);
    };

    const asyncGetList = (params) => {
      emit('getList', params);
    };

    const layout = computed(() =>
      props.count > 50 ? 'prev, pager, next, sizes, jumper, total' : 'prev, pager, sizes, total',
    );

    const handleSizeChange = (val) => {
      const { query } = props;
      query.pageSize = val;
      query.currentPage = 0;
      setQuery(props.query);
      asyncGetList(props.query);
    };

    const handleCurrentChange = (val) => {
      const { query } = props;
      query.currentPage = val - 1;
      setQuery(props.query);
      asyncGetList(props.query);
    };

    return {
      setQuery,
      asyncGetList,
      layout,
      handleSizeChange,
      handleCurrentChange,
    };
  },
});
